const endpoint = 'https://lyr37vn7zmom2zys4uuhk4ppfi0gsvgs.lambda-url.us-east-1.on.aws/';

export async function sendMessage(question) {
  const sessionId = 'sess-' + Math.random().toString(36).substring(2, 10);

  if (!question || typeof question !== 'string') {
    throw new Error("Invalid question input");
  }

  console.log('Endpoint configurado:', endpoint);
  console.log('Sending message:', { question, sessionId });

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ question, sessionId }) // ← esta línea estaba incompleta
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error completo:', error);
    throw error;
  }
}
